const calculateHorizontalPosition = (
  buttonRect,
  calendarWidth,
  horizontalPosition,
  availableWidth
) => {
  // For position: fixed, buttonRect coordinates are already viewport-relative
  // So we use them directly without subtracting documentRectLeft
  if (horizontalPosition === 'right') {
    // Align calendar's right edge with button's right edge
    let left = buttonRect.right - calendarWidth;

    // Check if calendar would go out of bounds on the left
    if (left < 0) {
      // If it would go out of bounds, align left edge with button's left edge instead
      left = buttonRect.left;
    }

    return left;
  }

  // Default: align calendar's left edge with button's left edge
  let left = buttonRect.left;

  // Check if calendar would go out of bounds on the right
  if (left + calendarWidth > availableWidth) {
    // If it would go out of bounds, align right edge with button's right edge instead
    left = buttonRect.right - calendarWidth;
  }

  return left;
};

export const calculateCalendarPosition = ({
  buttonRect,
  calendarWidth,
  calendarHeight,
  availableWidth,
  availableHeight,
  documentRectLeft,
  position = 'left'
}) => {
  // Handle case where calendar dimensions are not available yet
  if (!calendarWidth || !calendarHeight) {
    return {
      left: buttonRect.left - documentRectLeft,
      top: buttonRect.bottom
    };
  }

  // Extract horizontal and vertical preferences from position
  // Position can be 'left', 'right', 'top', 'bottom', or combinations like 'top-left', 'bottom-right'
  const positionParts = position.split('-');
  const verticalPosition = positionParts.find((p) => p === 'top' || p === 'bottom') || 'bottom';
  const horizontalPosition = positionParts.find((p) => p === 'left' || p === 'right') || 'left';

  // Calculate space constraints
  const hasSpaceBottom = buttonRect.bottom + calendarHeight <= availableHeight;
  const hasSpaceTop = buttonRect.top - calendarHeight >= 0;

  // Case 1: No space top and no space bottom - show in center
  if (!hasSpaceTop && !hasSpaceBottom) {
    const centerTop = Math.max(0, (availableHeight - calendarHeight) / 2);
    const left = calculateHorizontalPosition(
      buttonRect,
      calendarWidth,
      horizontalPosition,
      availableWidth
    );

    return {
      left,
      top: centerTop
    };
  }

  // Calculate vertical position
  let top;
  if (verticalPosition === 'top') {
    // Show above button
    top = buttonRect.top - calendarHeight - 8;
    // If it would go out of bounds, show below instead
    if (top < 0 || !hasSpaceTop) {
      top = buttonRect.bottom;
    }
  } else {
    // Default: show below button
    top = buttonRect.bottom;
    // If it would go out of bounds, show above instead
    if (top + calendarHeight > availableHeight || !hasSpaceBottom) {
      top = Math.max(0, buttonRect.top - calendarHeight - 8);
    }
  }

  // Calculate horizontal position
  const left = calculateHorizontalPosition(
    buttonRect,
    calendarWidth,
    horizontalPosition,
    availableWidth
  );

  return {
    left,
    top
  };
};
